import { AxiosRequestConfig } from 'axios';

import { get } from './client';

export async function fetcher<T, F>(path: string, params?: AxiosRequestConfig<F>) {
  // @ts-ignore
  const { data } = await get<T>(path, params);

  return data;
}
